import React from 'react';

import { SpacerProps, SpacerPropsDefaults } from '@usewaypoint/block-spacer';
import { Box } from 'components';
import { ArrowSwapVertical } from 'iconsax-react';

import { BaseSidebarPanel, SliderInput } from './inputs';

import { useTranslation } from 'third-party';

type Props = {
  data: SpacerProps;
  setData: (v: SpacerProps) => void;
};

export const SpacerSidebarPanel: React.FC<Props> = ({ data, setData }) => {
  const { t } = useTranslation();
  return (
    <BaseSidebarPanel title={t('emailDesigner.panel.spacer')}>
      <SliderInput
        label="Height"
        iconLabel={
          <Box sx={{ color: 'text.secondary' }}>
            <ArrowSwapVertical variant="TwoTone" size="24" />
          </Box>
        }
        units="px"
        step={4}
        min={4}
        max={128}
        defaultValue={data.props?.height ?? SpacerPropsDefaults.height}
        onChange={height =>
          setData({ ...data, props: { ...data.props, height } })
        }
      />
    </BaseSidebarPanel>
  );
};
